/*
  Papel Magazines · Ficha de producto
  En los números con varias portadas, hasta que el cliente toca una portada:
  - el botón muestra «Elige una portada» (en verde) y no añade al carrito;
  - pulsarlo lleva al selector de portadas y lo resalta.
  El selector y el formulario son los estándar del tema; esto solo añade el paso de elegir.
*/
(function () {
  function init(root) {
    if (!root || root.dataset.pmInit) return;
    root.dataset.pmInit = '1';
    if (root.dataset.pmMulti !== 'true') return;
    // Si se entra con una portada ya elegida en el enlace (?variant=), no se pide elegir
    if (new URLSearchParams(window.location.search).has('variant')) return;
    root.classList.add('pm-needs-choice');
    root.addEventListener('click', function (event) {
      if (event.target.closest('variant-selects input, variant-selects label')) {
        root.classList.remove('pm-needs-choice');
      }
    });
    root.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects')) root.classList.remove('pm-needs-choice');
    });
  }

  // Antes que el formulario del tema: si falta elegir portada, no se añade al carrito
  document.addEventListener(
    'submit',
    function (event) {
      var root = event.target.closest('product-info');
      if (!root || !root.classList.contains('pm-needs-choice')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var picker = root.querySelector('.pm-covers') || root.querySelector('variant-selects');
      if (!picker) return;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker.classList.add('pm-flash');
      setTimeout(function () {
        picker.classList.remove('pm-flash');
      }, 1400);
    },
    true
  );

  function start() {
    document.querySelectorAll('product-info[data-pm-multi="true"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
